'use strict';

var colorManipulator = require('../node_modules/@material-ui/core/styles/colorManipulator.js');

var fade = colorManipulator.fade;

module.exports = fade;
